<template>
  <div>
    <!-- //^ ^--------------新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      :title="title"
      :visible.sync="dialog.visible"
      append-to-body
      :modal-append-to-body="false"
      @closed="beforeClose"
      width="50%"
    >
      <!-- 表单 -->
      <el-form :model="params" :rules="rules" label-width="120px" ref="form">
        <el-form-item label="公司名称：" prop="companyName">
          <el-input
            style="padding-right: -30px"
            maxlength="99"
            show-word-limit
            v-model="params.companyName"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司备注：" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 99 }"
            maxlength="999"
            show-word-limit
            v-model="params.remark"
            placeholder="请输入公司备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 保存-取消 -->
      <span slot="footer" style="flex-end">
        <el-button @click="hide">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Message from '@/components/Message'
import {
  addEnterpriseDistribution,
  updateEnterpriseDistribution
} from '@/api/enterpriseDistribution/companyManage/index.js'
export default {
  name: 'WebSassAdd',
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          id: '',
          companyName: '',
          remark: ''
        }
      }
    }
  },
  computed: {
    /** 是否是编辑 */
    title() {
      return this.params.id ? '编辑公司' : '新增公司'
    }
  },
  data() {
    return {
      dialog: {
        visible: false,
        title: this.params.id ? '编辑公司' : '新增公司'
      },
      rules: {
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }
        ],
        remark: [
          {
            required: false,
            message: '请输入公司备注',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // ^ ^--------------对话框内的事件-------------^ ^
    /** 确认的事件 */
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          if (this.params.id) {
            /** 编辑 */
            const { data } = await updateEnterpriseDistribution(this.params)
            console.log('编辑的响应', data)
            if (data.code === 200) {
              Message.success('编辑成功')
              this.$emit('refresh')
            }
          } else {
            /** 新增 */
            const { data } = await addEnterpriseDistribution({
              companyName: this.params.companyName,
              remark: this.params.remark
            })
            console.log('新增的响应', data)
            if (data.code === 200) {
              Message.success('保存成功')
              this.$emit('refresh')
            }
          }

          this.hide()
        } else {
          /** 验证失败 */
          Message.error('请检查表单')
        }
      })
    },
    show(row) {
      if (row) {
        console.log('编辑', row)
        this.params = { ...row }
      }
      this.dialog.visible = true
    },
    hide() {
      /** 隐藏对话框 */
      this.dialog.visible = false
      /** 清理表单数据 */
      this.$refs.form.clearValidate()
    },
    beforeClose() {
      console.log('beforeClose')
      /** 清理表单数据 */
      this.$refs.form.resetFields()
      this.params.id = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  padding-right: 50px !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>